export const BASE_URL = 'https://api.automation.afaqtel.ir/api';
// export const BASE_URL = 'http://localhost:5000/api';
export const STATIC_URL = 'https://api.automation.afaqtel.ir/files';
// export const STATIC_URL = 'http://localhost:5000/files/';
export const SIGN_IN_URL = '/auth/login';
export const USERS_URL = BASE_URL + '/auth/users';
export const PROFILE_URL = BASE_URL + '/auth/profile';
export const UPLOAD_EXCEL_URL = BASE_URL + '/admin-4jxlqTk1b/insert-device-excel';
export const DEVICE_OVERALL_URL = '/admin-4jxlqTk1b/device-overall-info';
export const UPLOADED_FILES_URL = BASE_URL + '/admin-4jxlqTk1b/uploaded-files';
export const DEVICE_MODELS_URL = BASE_URL + '/details';
export const DEVICES_URL = BASE_URL + '/devices';
export const FORCE_REGISTER_URL = BASE_URL + '/admin-4jxlqTk1b/register-device';
export const GUARANTEES_PARTS_INFO_URL = BASE_URL + '/inventory/parts/guarantees';

export const INVENTORY_URL = BASE_URL + '/inventory/';
export const AVAILABLE_MODELS_URL = BASE_URL + '/inventory/available-models';
export const AVAILABLE_URL = BASE_URL + '/inventory/available';
export const BRANDS_URL = BASE_URL + '/inventory/brands/';
export const COLORS_URL = BASE_URL + '/inventory/colors';
export const MODELS_URL = BASE_URL + '/inventory/models';
export const PROFORMAS_URL = BASE_URL + '/sales/proformas';
export const INVOIECES_URL = BASE_URL + '/sales/invoices';
export const FIRMS_URL = BASE_URL + '/sales/firms';
export const BANK_ACCOUNTS_URL = BASE_URL + '/sales/bank-accounts';
export const INSERT_URL = BASE_URL + '/inventory/insert';
export const EXPORT_URL = BASE_URL + '/inventory/export';
export const DELIVER_URL = BASE_URL + '/inventory/deliver';
export const ADD_DETAILS_URL = BASE_URL + '/inventory/add-details';

export const PARTS_URL = BASE_URL + '/inventory/parts';
export const BOX_STATUS_URL = (partId, boxNumber) => BASE_URL + `/inventory/parts/${partId}/box/${boxNumber}`;

export const WEBSOCKET_ADDRESS = 'ws://localhost:5000/ws'
